import React from 'react'

export default function Mic({ className, style }) {
  return (
    <svg viewBox="0 0 10 11" className={className} style={style}>
      <path
        fill="currentColor"
        d="M9.678,6.016 L0.957,10.906 C0.540,11.140 0.014,10.853 0.014,10.391 L0.014,0.610 C0.014,0.148 0.540,-0.138 0.957,0.095 L9.678,4.986 C10.089,5.217 10.089,5.785 9.678,6.016 Z"
      />
    </svg>
  )
}
